import React, { Component } from 'react';
import { Form, Control } from 'react-redux-form';
import { last, sortBy } from 'lodash';

import Textfield from '../../ui/text-field';
import Textarea from '../../ui/textarea';
import Checkbox from '../../ui/checkbox';
import Select from '../../ui/select';
import Modal from '../../ui/modal';

import validators from '../../../helpers/validators';
import validObj from '../../../helpers/validateObj';
import aaSave from '../../../helpers/afterActionSave';
import aaValidation from '../../../helpers/afterActionValidation';

import * as endpoints from '../../../helpers/endpoints';

class General extends Component {
    handleSubmit = e => {
        const formObj = validObj(e);
        formObj.id = formObj.reportId;
        switch (this.props.userAction) {
            case 'save':
                formObj.deliverable = formObj.aadeliverable;
                formObj.recommend = formObj.aaRecommend;
                formObj.approverId = formObj.aaApproverId;
                this.props.updateAfterAction(formObj);
                break;
            case 'submit':
                const notValid = aaValidation(e);
                if (!notValid) {
                    formObj.deliverable = formObj.aadeliverable;
                    formObj.recommend = formObj.aaRecommend;
                    this.props.submitAfterAction(formObj);
                } else {
                    this.props.setEventErrorMessage(notValid);
                    if (e.aaawareness !== true && e.aabehavior !== true) {
                        this.props.setFormFieldValidity(
                            'event.aaawareness',
                            false
                        );
                        this.props.setFormFieldValidity(
                            'event.aabehavior',
                            false
                        );
                    } else if (
                        e.aaawareness === true ||
                        e.aabehavior === true
                    ) {
                        this.props.setFormFieldValidity(
                            'event.aaawareness',
                            true
                        );
                        this.props.setFormFieldValidity(
                            'event.aabehavior',
                            true
                        );
                    }
                }
                break;
            case 'approve':
                this.props.approveAfterAction(formObj);
                break;
            case 'request':
                this.props.requestInfoAfterAction(formObj);
                break;
            default:
                console.log(this.props.userAction);
        }
    };

    handleSubmitFailed = e => {
        if (this.props.userAction === 'save') {
            const values = aaSave(e);
            this.props.updateAfterAction(values);
        }
        if (this.props.userAction === 'submit') {
            const values = aaSave(e);
            const notValid = aaValidation(values);
            if (notValid) {
                if (values.aaawareness !== true && values.aabehavior !== true) {
                    this.props.setFormFieldValidity('event.aaawareness', false);
                    this.props.setFormFieldValidity('event.aabehavior', false);
                } else if (
                    values.aaawareness === true ||
                    values.aabehavior === true
                ) {
                    this.props.setFormFieldValidity('event.aaawareness', true);
                    this.props.setFormFieldValidity('event.aabehavior', true);
                }
            }
        }
        if (this.props.userAction === 'request') {
            const values = aaSave(e);
            this.props.requestInfoAfterAction(values);
        }
    };

    onCheckboxChange() {
        this.props.setFormFieldValidity('event.aaawareness', true);
        this.props.setFormFieldValidity('event.aabehavior', true);
    }

    componentDidMount() {
        if (this.props.approvers && this.props.approvers.length === 1) {
            this.props.setApproverVal(this.props.approvers[0].code);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.approvers !== nextProps.approvers) {
            if (nextProps.approvers.length === 1) {
                this.props.setApproverVal(nextProps.approvers[0].code);
            }
        }
    }

    render() {
        let reqApprovers = validators.approver();
        let textVal = validators.trimVal();

        let saveSubmit = false;
        let approveReject = false;
        let disableApprover = false;
        let showApprover = true;
        let userInfo = this.props.userInfo;
        const trustingUserId = userInfo.TrustingUser
            ? userInfo.TrustingUser.id
            : null;

        if (
            this.props.groupStatus.status === 'After Action Incomplete' ||
            this.props.groupStatus.status === 'After Action Pending'
        ) {
            if (
                this.props.afterActionUserID === this.props.userInfo.id ||
                this.props.afterActionUserID === trustingUserId
            ) {
                saveSubmit = true;
                showApprover = true;
            }
        } else if (
            this.props.eventState.EventReport.status === 'Unapproved' &&
            this.props.groupStatus.status === 'After Action Review' &&
            this.props.tasks &&
            this.props.tasks.length > 0
        ) {
            const mostRecentTask = last(sortBy(this.props.tasks, 'id'));

            if (mostRecentTask.userId === this.props.userInfo.id) {
                if (mostRecentTask.action === 'Info') {
                    saveSubmit = true;
                    showApprover = true;
                } else {
                    approveReject = true;
                    showApprover = true;
                }
            } else if (trustingUserId) {
                if (mostRecentTask.userId === trustingUserId) {
                    if (mostRecentTask.action === 'Info') {
                        saveSubmit = true;
                        showApprover = true;
                    } else {
                        approveReject = true;
                        showApprover = true;
                    }
                }
            }
        } else {
            disableApprover = true;
        }

        if (
            this.props.aaStatus === 'Approved' ||
            this.props.aaStatus === 'Submitted' ||
            this.props.aaStatus === 'RFI'
        ) {
            showApprover = true;
            disableApprover = true;
        }

        return (
            <Form
                className="form"
                model="event"
                encType="multipart/form-data"
                onSubmit={this.handleSubmit}
                onSubmitFailed={this.handleSubmitFailed}
            >
                <div className="tab__title">General</div>

                <Textarea
                    model="event.description"
                    isRequired
                    title="Description"
                    tooltip="Summarize how you are affecting awareness and/or behavior, with whom and how "
                    validators={saveSubmit ? { textVal } : undefined}
                    messages={
                        saveSubmit ? { textVal: textVal.message } : undefined
                    }
                    disabled={!saveSubmit}
                    maxLength={1000}
                />

                <Textarea
                    model="event.objective"
                    isRequired
                    title="Objective"
                    tooltip="What is the overall intent of the event"
                    validators={saveSubmit ? { textVal } : undefined}
                    messages={
                        saveSubmit ? { textVal: textVal.message } : undefined
                    }
                    disabled={!saveSubmit}
                    maxLength={1000}
                />

                <div className="form__section-title">
                    Measurement of Effectiveness{' '}
                    <span className="form__note">
                        (NOTE: ALL METRICS ARE SELF-REPORTED.)
                    </span>
                </div>
                <Checkbox
                    model="event.aaawareness"
                    title="AWARENESS & ATTITUDE"
                    isRequired
                    onChange={this.onCheckboxChange.bind(this)}
                    options={[
                        { name: 'SELECT IF OBJECTIVE IS AWARENESS', code: '0' }
                    ]}
                    disabled={!saveSubmit}
                />

                <Textfield
                    model="event.engagements"
                    isRequired
                    type="number"
                    title="NUMBER OF DIRECT ENGAGEMENTS BETWEEN MARINES AND EVENT ATTENDEES"
                    tooltip="Number of people engaged with one-on-one"
                    validators={saveSubmit ? { textVal } : undefined}
                    messages={
                        saveSubmit ? { textVal: textVal.message } : undefined
                    }
                    disabled={!saveSubmit}
                    onKeyPress
                    min="0"
                />

                <Textfield
                    model="event.mediaPosts"
                    isRequired
                    type="number"
                    title="NUMBER OF TRADITIONAL MEDIA POSTS"
                    tooltip="Print media articles or insertions, TV/cable features or reports, digital media placements"
                    validators={saveSubmit ? { textVal } : undefined}
                    messages={
                        saveSubmit ? { textVal: textVal.message } : undefined
                    }
                    disabled={!saveSubmit}
                    onKeyPress
                    min="0"
                />

                <Textfield
                    model="event.mediaImpressions"
                    isRequired
                    type="number"
                    title="NUMBER OF TRADITIONAL MEDIA IMPRESSIONS"
                    tooltip="Impressions from print, TV/cable, digital"
                    validators={saveSubmit ? { textVal } : undefined}
                    messages={
                        saveSubmit ? { textVal: textVal.message } : undefined
                    }
                    disabled={!saveSubmit}
                    onKeyPress
                    min="0"
                />

                <Textfield
                    model="event.socialMediaPosts"
                    isRequired
                    type="number"
                    title="NUMBER OF SOCIAL MEDIA POSTS"
                    validators={saveSubmit ? { textVal } : undefined}
                    messages={
                        saveSubmit ? { textVal: textVal.message } : undefined
                    }
                    disabled={!saveSubmit}
                    onKeyPress
                    min="0"
                />

                <Textfield
                    model="event.socialMediaImpressions"
                    isRequired
                    type="number"
                    title="NUMBER OF SOCIAL MEDIA IMPRESSIONS"
                    validators={saveSubmit ? { textVal } : undefined}
                    messages={
                        saveSubmit ? { textVal: textVal.message } : undefined
                    }
                    disabled={!saveSubmit}
                    onKeyPress
                    min="0"
                />

                <Checkbox
                    model="event.aabehavior"
                    isRequired
                    title="Behavior"
                    onChange={this.onCheckboxChange.bind(this)}
                    options={[
                        { name: 'SELECT IF OBJECTIVE IS BEHAVIOR', code: '0' }
                    ]}
                    disabled={!saveSubmit}
                />

                <Textfield
                    model="event.influencerContacts"
                    isRequired
                    type="number"
                    tooltip="Number of coaches, educators, parents, etc. who provided contact information (for entry into ECCI)"
                    title="NUMBER OF INFLUENCER CONTACTS GENERATED"
                    validators={saveSubmit ? { textVal } : undefined}
                    messages={
                        saveSubmit ? { textVal: textVal.message } : undefined
                    }
                    disabled={!saveSubmit}
                    onKeyPress
                    min="0"
                />

                <Textfield
                    model="event.followUps"
                    isRequired
                    type="number"
                    title="NUMBER OF FOLLOW-ON ENGAGEMENTS SCHEDULED"
                    tooltip="Number of CFT, school talks, etc. scheduled post-event"
                    validators={saveSubmit ? { textVal } : undefined}
                    messages={
                        saveSubmit ? { textVal: textVal.message } : undefined
                    }
                    disabled={!saveSubmit}
                    onKeyPress
                    min="0"
                />

                <Textfield
                    model="event.interaction"
                    isRequired
                    type="number"
                    title="NUMBER OF PROSPECTS THAT INTERACTED WITH THE MARINE BOOTH OR OTHER ACTIVATION SETUP"
                    tooltip="Number of prospect-aged youth that interacted with Marines at the activation set up"
                    validators={saveSubmit ? { textVal } : undefined}
                    messages={
                        saveSubmit ? { textVal: textVal.message } : undefined
                    }
                    disabled={!saveSubmit}
                    onKeyPress
                    min="0"
                />

                <Textfield
                    model="event.influencerInteraction"
                    isRequired
                    type="number"
                    title="NUMBER OF INFLUENCERS THAT INTERACTED WITH THE MARINE BOOTH OR OTHER ACTIVATION SETUP"
                    tooltip="Number of coaches, educators, parents, etc. that interacted with Marines at the activation set up"
                    validators={saveSubmit ? { textVal } : undefined}
                    messages={
                        saveSubmit ? { textVal: textVal.message } : undefined
                    }
                    disabled={!saveSubmit}
                    onKeyPress
                    min="0"
                />

                <Textarea
                    model="event.concerns"
                    isRequired
                    title="CONCERNS OR PROBLEMS AT EVENT?"
                    tooltip="What issues were encountered"
                    validators={saveSubmit ? { textVal } : undefined}
                    messages={
                        saveSubmit ? { textVal: textVal.message } : undefined
                    }
                    disabled={!saveSubmit}
                    maxLength={750}
                />

                <Textarea
                    model="event.aadeliverable"
                    isRequired
                    title="PERSONAL IN NATURE DELIVERABLES WITH ASSOCIATED CONTROL MEASURES?"
                    tooltip="Items that could be considered personal in nature (i.e. tickets, access to events or gear) and how they are being accounted for and monitored"
                    validators={saveSubmit ? { textVal } : undefined}
                    messages={
                        saveSubmit ? { textVal: textVal.message } : undefined
                    }
                    disabled={!saveSubmit}
                    maxLength={500}
                />

                <Textfield
                    model="event.attendance"
                    isRequired
                    type="number"
                    tooltip="How many people actually attended the event"
                    title="ACTUAL ATTENDEES"
                    validators={saveSubmit ? { textVal } : undefined}
                    messages={
                        saveSubmit ? { textVal: textVal.message } : undefined
                    }
                    disabled={!saveSubmit}
                    onKeyPress
                    min="0"
                />

                <Textfield
                    model="event.leadCards"
                    tooltip="How many lead cards did you turn in"
                    isRequired
                    type="number"
                    title="PAPER CARDS"
                    validators={saveSubmit ? { textVal } : undefined}
                    messages={
                        saveSubmit ? { textVal: textVal.message } : undefined
                    }
                    disabled={!saveSubmit}
                    onKeyPress
                    min="0"
                />

                {showApprover && this.props.approvers.length > 1 ? (
                    <Select
                        model="event.aaApproverId"
                        title="Assign for Approval"
                        options={this.props.approvers}
                        isRequired
                        validators={{ reqApprovers }}
                        messages={{ reqApprovers: reqApprovers.message }}
                        disabled={disableApprover}
                    />
                ) : null}

                <div className="download">
                    <div className="download__body">
                        <p>
                            To generate the Source Code Coversheet, please
                            select the Generate button below. Lead Cards
                            Submitted must be entered prior to generating the
                            coversheet.
                        </p>
                        <p>
                            <a
                                className="btn btn--submit"
                                href={`${endpoints.EVENT_SOURCE_CODE_PATH}?id=${
                                    this.props.eventId
                                }&t=${this.props.jwtToken}`}
                                target="_blank"
                                title="Generate Source Code Coversheet"
                            >
                                Generate
                            </a>
                        </p>
                    </div>
                </div>

                <Control.text
                    model="event.hidden"
                    type="hidden"
                    value="eventId"
                    disabled={!saveSubmit}
                />

                <div className="form__actions form__actions--global">
                    {saveSubmit ? (
                        <Control.button
                            className="btn btn--secondary btn--save"
                            type="submit"
                            model="event.userActionTaken"
                            value="save"
                            onClick={() => {
                                this.props.setEventUserAction('save');
                            }}
                        >
                            Save
                        </Control.button>
                    ) : null}
                    {saveSubmit ? (
                        <Control.button
                            className="btn btn--submit"
                            type="submit"
                            model="event.userActionTaken"
                            value="submit"
                            onClick={() => {
                                this.props.setEventUserAction('submit');
                            }}
                        >
                            Submit
                        </Control.button>
                    ) : null}
                    {approveReject ? (
                        <Control.button
                            className="btn btn--secondary"
                            type="submit"
                            model="event.userActionTaken"
                            value="approve"
                            onClick={() => {
                                this.props.setEventUserAction('approve');
                            }}
                        >
                            Approve
                        </Control.button>
                    ) : null}
                    {approveReject ? (
                        <Modal
                            title="Returned for Edit"
                            classes="btn btn--secondary"
                            closeButtonCopy="Cancel"
                            toggleAction={this.props.requestModalActive}
                            toggleModal={this.props.toggleRequestModal}
                            submitAction={this.props.setEventUserAction}
                            submitValue={'request'}
                        >
                            <div className="form__section-title">
                                Returned for Edit
                            </div>
                            <Textfield
                                model="event.aaRequestComments"
                                title="Comments"
                                maxLength="250"
                            />
                        </Modal>
                    ) : null}
                </div>
            </Form>
        );
    }
}

export default General;



// WEBPACK FOOTER //
// ./src/components/event/after-action/general.js